export default accessToken => {
  const accessTokenChunk = String(accessToken).split('|');
  const memberlogin = accessTokenChunk[1];
  const cryptedStr = accessTokenChunk[0];
  return `${memberlogin}--${cryptedStr.substr(0, 10)}`;
};
